import IconSinister from '@mercadoni/sinister/dist/cjs/Icon'

const IconLogic = ({ icon, color }: { icon: string; color: string }) => {
  const style = {
    marginRight: 'var(--spacing-margin-xSmall)',
    flexShrink: '0',
    color: color ? `var(${color})` : '#000000',
  }

  return <IconSinister size={20} className={icon} style={style} />
}

const Icon = ({ icon, color }: { icon: string; color: string }) => (
  <IconLogic icon={icon} color={color} />
)

export default Icon
